module.exports = __webpack_public_path__ + "me_logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/me_logo.svg
// module id = 108
// module chunks = 0